import React from 'react'
import {
  CheckCircleOutlined,
  SafetyCertificateOutlined,
} from '@ant-design/icons'
import styled from 'styled-components/macro'
import GrowthEngineHumanDemoRow from 'src/components/growthEngine/GrowthEngineHumanDemoRow'
import {
  GOODS_RECEIPTING_PLAN_PILLS,
  getGoodsReceiptingLimitReachedCopy,
} from 'src/utils/growthEngineGoodsReceiptingLimit'

/**
 * Lite (internal Free) at-limit: Express why (celebrate + credits + Starter), then compact
 * human row, then plan pills. Paid at-limit: help-led, no upgrade tone.
 */
const GoodsReceiptingLimitUpsell = ({
  copy,
  recommendation,
  guidedSuccess,
  plan,
  className,
  'data-testid': dataTestId = 'goods-receipting-limit-upsell',
}) => {
  const resolved =
    copy && (copy.title || copy.body)
      ? copy
      : getGoodsReceiptingLimitReachedCopy({
          recommendation,
          guidedSuccess,
          plan,
        })

  return (
    <Wrap className={className} data-testid={dataTestId}>
      <UpsellHero>
        <HeroIcon>
          <SafetyCertificateOutlined />
        </HeroIcon>
        <HeroCopy>
          {resolved.title ? <HeroTitle>{resolved.title}</HeroTitle> : null}
          {resolved.body ? <HeroText>{resolved.body}</HeroText> : null}
        </HeroCopy>
      </UpsellHero>

      <GrowthEngineHumanDemoRow compact featureId='goods_receipting' />

      {resolved.showPlanPills !== false ? (
        <PlanRow data-testid='goods-receipting-limit-pills'>
          {GOODS_RECEIPTING_PLAN_PILLS.map(label => (
            <PlanPill key={label}>
              <CheckCircleOutlined style={{ color: '#52c41a' }} />
              {label}
            </PlanPill>
          ))}
        </PlanRow>
      ) : null}

      {resolved.showPlanPills !== false ? (
        <UpsellNote>
          OMS Lite includes 1 reconciled PO per month. Limits reset each
          calendar month.
        </UpsellNote>
      ) : null}
    </Wrap>
  )
}

const Wrap = styled.div`
  min-width: 0;
`

const UpsellHero = styled.div`
  display: flex;
  gap: 14px;
  align-items: flex-start;
  padding: 16px;
  border-radius: 12px;
  background: linear-gradient(135deg, #f6ffed 0%, #fcfff5 100%);
  border: 1px solid #d9f7be;
  margin-bottom: 12px;
`

const HeroIcon = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #b5d922;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
`

const HeroCopy = styled.div`
  min-width: 0;
`

const HeroTitle = styled.h3`
  margin: 0 0 6px;
  font-size: 20px;
  font-weight: 700;
  color: #262626;
  line-height: 1.3;
`

const HeroText = styled.p`
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  color: #595959;
`

const PlanRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 14px 0 12px;
`

const PlanPill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  background: #fff;
  border: 1px solid #d9d9d9;
  color: #434343;
  font-size: 13px;
  font-weight: 600;
`

const UpsellNote = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #8c8c8c;
`

export default GoodsReceiptingLimitUpsell
